import ReactMarkdown from "react-markdown";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { HiExternalLink } from "react-icons/hi";
import { PiCheckBold } from "react-icons/pi";
import { guidelineText } from "../../utils";

const RecommendationsSection = ({ guidelines, onGuidelineValidatedChange }) => {
  const [animateRef] = useAutoAnimate();

  if (!guidelines?.length) return null;

  return (
    <div className="mb-4">
      <div className="mb-2">
        <div className="section-title">
          <span>Recommandations</span>
          <span className="meta-badge bg-gray-100 text-gray-500">{guidelines.length}</span>
        </div>
      </div>

      <div ref={animateRef} className="card divide-y divide-gray-100">
        {guidelines.map((guideline) => {
          const isValidated = guideline.validated === true;
          const needsAttention = guideline.secretary && !isValidated;

          return (
            <div key={guideline._id} className="flex items-start gap-2.5 px-4 py-2.5">
              <button
                type="button"
                role="checkbox"
                aria-checked={isValidated}
                title={isValidated ? "Marquer comme non validée" : "Marquer comme validée"}
                onClick={() => onGuidelineValidatedChange(guideline._id, !isValidated)}
                className={`mt-px flex size-[18px] shrink-0 items-center justify-center rounded-md border transition-colors ${
                  isValidated
                    ? "border-primary-500 bg-primary-500 text-white"
                    : `bg-white text-transparent ${needsAttention ? "border-orange-300 hover:border-orange-500" : "border-gray-300 hover:border-primary-400"}`
                }`}
              >
                <PiCheckBold className="size-2.5" />
              </button>

              <div className={`min-w-0 flex-1 text-[13px] leading-snug ${isValidated ? "text-gray-400 line-through" : needsAttention ? "text-orange-600" : "text-gray-800"}`}>
                <ReactMarkdown
                  components={{
                    a: (props) => (
                      <a {...props} target="_blank" rel="noopener noreferrer" className="flex items-center text-primary-600 underline hover:text-primary-800">
                        <HiExternalLink className="h-4 w-4" />
                        {props.children}
                      </a>
                    ),
                    p: (props) => (
                      <p {...props} className="whitespace-pre-line">
                        {props.children}
                      </p>
                    ),
                    ul: (props) => <ul {...props} className="list-inside list-disc space-y-1" />,
                    li: (props) => <li {...props} className="whitespace-pre-line" />,
                  }}
                >
                  {guidelineText(guideline)}
                </ReactMarkdown>
              </div>

              <div className="flex shrink-0 items-center gap-1.5">
                {guideline.secretary && (
                  <span className="inline-flex items-center rounded-full border border-orange-200 bg-orange-50 px-1.5 text-[10px] font-medium leading-tight text-orange-700">
                    Secrétaire
                  </span>
                )}
                {guideline.patient && (
                  <span className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-1.5 text-[10px] font-medium leading-tight text-blue-700">
                    Patient
                  </span>
                )}
                {guideline.ide && (
                  <span className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-1.5 text-[10px] font-medium leading-tight text-gray-500">IDE</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecommendationsSection;
